import { G as useRecordVisibilityChanges, p as jsxRuntimeExports } from "./doenetml-NmXDuMHr.js";
import React__default, { useRef } from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-iiMuPv8N.js";
import { a as getBlockMarginWithOptionalTopSuppression } from "./nonInlineMediaLayout-CkXHaqzo.js";
function isWhitespaceTextChild(child) {
  return typeof child === "string" && child.trim() === "";
}
function isRenderablePanelChild(child) {
  if (!child) {
    return false;
  }
  if (typeof child === "string") {
    return false;
  }
  return typeof child === "object" && "key" in child;
}
const sideBySide = React__default.memo(function sideBySide2(props) {
  let { id, SVs, children, actions, callAction } = useDoenetRenderer(props);
  const ref = useRef(null);
  useRecordVisibilityChanges(ref, callAction, actions);
  if (SVs.hidden) {
    return null;
  }
  let styledChildren = [];
  const marginStart = SVs.margins[0];
  const marginEnd = SVs.margins[1];
  const listItemInlineAlignment = SVs.listItemInlineAlignment === "none" ? null : SVs.listItemInlineAlignment;
  let panelSlotCount = 0;
  for (const child of children) {
    if (!isWhitespaceTextChild(child)) {
      panelSlotCount += 1;
    }
  }
  const numColumns = SVs.numPanels ?? panelSlotCount;
  let panelIndex = 0;
  for (const child of children) {
    if (isWhitespaceTextChild(child)) {
      continue;
    }
    const currentPanelIndex = panelIndex;
    panelIndex += 1;
    if (!isRenderablePanelChild(child)) {
      continue;
    }
    let width = SVs.widths[currentPanelIndex];
    let thisMarginStart = marginStart;
    let thisMarginEnd = marginEnd;
    if (currentPanelIndex > 0) {
      thisMarginStart += SVs.gapWidth / 2;
    }
    if (currentPanelIndex < numColumns - 1) {
      thisMarginEnd += SVs.gapWidth / 2;
    }
    styledChildren.push(
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "span",
        {
          style: {
            ...listItemInlineAlignment && {
              display: "flex",
              alignItems: "flex-start"
            },
            marginInlineStart: `${thisMarginStart}%`,
            marginInlineEnd: `${thisMarginEnd}%`,
            width: `${width}%`
          },
          children: child
        },
        child.key
      )
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      id,
      style: {
        display: "flex",
        ...listItemInlineAlignment && {
          alignItems: listItemInlineAlignment
        },
        maxWidth: "850px",
        margin: getBlockMarginWithOptionalTopSuppression({
          suppressTopMargin: Boolean(listItemInlineAlignment)
        })
      },
      ref,
      children: styledChildren
    }
  );
});
export {
  sideBySide as default
};
